<template>
  <Modal v-model="showModel" title="机票预定须知" @on-cancel="cancel" :footer-hide="true">
    <div
      class="fontSize5 fontWeightCu redColor lineheight6"
    >在订单提交前，旅客应仔细阅读本须知，本须知内容具有法律约束力。成功提交订单的，则视为旅客已阅读并全部接受本须知内容。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">第一条 预订须知</div>
    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">1）婴儿、孕妇、老年人及其他有特殊要求旅客</div>
    <div class="fontSize35 color2 lineheight5">* 14天－2周岁的婴儿可以购买婴儿票，婴儿票网上不能单独提交，可成人+婴儿一起提交；</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 孕妇乘坐飞机有一定的限制条件，请在您计划旅行前及时告知您的医生关于您的旅行计划，征得医生的同意并出，具适航证明由于各个航司规定有所不同，请您应事先咨询航司，以航司确认为准。</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 各航司要求超出规定年龄以上的老年旅客，登机时需要提供航司要求的健康证明材料，证明身体状况达到乘坐飞机的要求；具体规定内容，请参考各航司官网公告。对于婴儿及其他有特殊要求的旅客，如无人陪伴儿童、病残旅客，因需办理有关的特殊服务手续，请向拨打0760-88880777咨询客服后方可下单。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">2）不宜乘机人群</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 心血管疾病患者、脑血管病、呼吸系统疾病患者，严重贫血的病人，耳鼻疾病患者，有大面积外伤的旅客，不宜乘飞机；</div>
    <div class="fontSize35 color2 lineheight5">* 做过胃肠手术的病人，一般在手术十天内不能乘坐飞机；</div>
    <div class="fontSize35 color2 lineheight5">* 消化道出血病人要在出血停止三周后才能乘飞机；</div>
    <div class="fontSize35 color2 lineheight5">* 传染性疾病患者，在国家规定的隔离期内，不能乘坐飞机，其中水痘病人在损害部位未痊愈，不能乘飞机。</div>
    <div class="fontSize35 color2 lineheight5">* 精神病患者，如癫痫及各种精神病人，不宜乘飞机，如有特殊情况，必须在症状控制后，咨询医生后再考虑乘机。</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 近期做过整容、整形或其他医疗美容手术的旅客，由于空中旅行压力要比地面大，即使机舱内调整了压力，但还是会有压力差，容易引起血压波动，导致伤口裂开、出血、感染等并发症，会增加术后病症发生的风险。为了您的飞行安全，请您在术后15天再乘坐飞机，并在办理值机手续时出具航班计划起飞前48小时内开具二级甲等医院(境外含诊所、医疗中心及医院)医生填写并加盖公章的诊断证明书以及证明其手术日期的病例。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">2、航班与价格</div>
    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">1）航班</div>
    <div class="fontSize35 color2 lineheight5">* 旅客输入查询条件检索后，所列航班为符合条件的全部航班，航班显示的时间均为当地时间。</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 旅客需要确保输入的查询条件与您的行程（日期、出发城市、到达城市）完全一致，如因旅客输入或选择有误，导致订购的机票不符合行程，所造成损失由旅客自行承担。我司平台提供的各类航班相关信息，包括但不限于舱位价格、餐食、起降准点率等，来源于中国航信、全国各大机场、航空公司及相关部门公布数据。由于这些信息可能随时变化，以及网络传输问题，因此仅供旅客作为一般参考，任何公司或个人不能将此作为我司机票售票平台的承诺或保证的依据。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">2）价格</div>
    <div class="fontSize35 color2 lineheight5">价格由票价、税金、燃油费、机场建设费、平台维护费五部分组成。</div>
    <div class="fontSize35 color2 lineheight5">* 票价：票价根据航空公司、舱位、有效期、退改签等规定而有所不同；</div>
    <div class="fontSize35 color2 lineheight5">* 税金：税金根据每天的汇率会有所浮动，具体以您出票时为准，网上标识为大概税金；</div>
    <div class="fontSize35 color2 lineheight5">* 燃油附加费：燃油附加费是航空公司因为燃油加价而增收的费用，每条航线有所不同；</div>
    <div class="fontSize35 color2 lineheight5">* 机场建设费：机场建设费是民航总局规定收取之费用，婴儿、儿童可以免收机场建设费；</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 平台维护费：用于网络平台开发及维护，将收取20元/张的平台维护费。机票价格以提交订单后支付页面显示的价格为准，支付金额为您预订的机票含税和订票服务费价格（不包含保险），如您有购买保险需求，需单独购买。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">3、订票须知</div>
    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">1）旅客基本信息</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 姓名及证件：必须用登机人证件姓名提交订单，如预订资料与乘机人证件资料不一致将无法登机，所造成的损失由预订人自行承担。</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 联系方式：请正确、详细的输入您的联系信息并保持通讯畅通，以便能及时地与您联系；如联系人、联系电话等资料有误，此订单将被视为无效订单作取消处理，从而导致不能及时确认、出票等问题我司平台将不承担责任。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">2）旅客类型选择</div>
    <div
      class="fontSize35 color2 lineheight5"
    >选择乘机人相应的身份,系统将根据您所提供的身份为您提供相应价格。无论您的身份是留学生、新移民、劳务人员或是儿童,只要您愿意接受 “普通”乘客类型的价格,也可以预订此价格。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">3）国际及港澳台单程票限制</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 出境机票中只有长期留学生签证、移民签证、一年以上的长期工作签证等签证类型才可以购买单程机票，其他商务和旅游类型的短期签证必须购买往返票；否则会由于目的地国家的相关政策限制，您将无法办理乘机和出境手续，请您务必确认核实后再购买单程票。</div>
    <div class="fontSize35 color2 lineheight5">* 中转机票签证提示：旅客预订国际中转机票时，需按照中转国相关政策，提前办理过境签证，否则将无法出行。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">4）重复订单</div>
    <div
      class="fontSize35 color2 lineheight5"
    >请勿提交重复订单（同一位登机人相同时间段两张以上的机票订单），如提交重复订单导致了重复出票，所产生的退票损失将由预订人全部承担。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">5）订单确认</div>
    <div
      class="fontSize35 color2 lineheight5"
    >确认方式有邮箱确认和手机短信确认，我司将按照您选择的确认方式与您确认所预订的航班、价格等问题。您所提供的联系信息请务必正确，保持畅通，如果订位不成功我司将会尽快电话联系告知；如所留的通讯方式无人接听、忙音等任何通讯问题而无法联系到预订人,从而导致不能及时确认、出票等问题我司将不承担责任。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">6）订单取消与修改</div>
    <div
      class="fontSize35 color2 lineheight5"
    >只有未支付、未出票的订单，旅客才能在网上在线取消。如果订单已经支付或出票请电话通知我司客服热线0760-88880777申请退票；如果您的出行需求发生变化，需要修改订单，请致电0760-88880777,由操作人员进行操作。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">7）出票</div>
    <div
      class="fontSize35 color2 lineheight5"
    >机位预订成功后，须在5分钟之内及时完成支付，才能最大程度确保旅客的机票可成功出票。如旅客的航班时间在7天以内的，机位保留时间有限，即订即售，需要旅客预订后立即完成付款。如因为航空公司取消订座原因，导致旅客预订的机位无法完成出票的，需要旅客重新查询预订，价格以新的为准。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">8）更改与退票</div>
    <div class="fontSize35 color2 lineheight5">机票使用原则：必须按照行程顺序使用机票；</div>
    <div class="fontSize35 color2 lineheight5">机票退票原则：按照各航空公司退票政策执行；</div>
    <div class="fontSize35 color2 lineheight5">机票签转原则：全价票可以签转，所有折扣机票都不允许签转其他航空公司；</div>
    <div class="fontSize35 color2 lineheight5">机票更改原则：更改限制与收费按照各航空公司政策文件执行。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">9）在线支付</div>
    <div
      class="fontSize35 color2 lineheight5"
    >旅客提交订单之后，直接在线完成支付。旅客银行卡需开通在线支付功能，及在线支付额度足够支付您的机票款，如选择信用卡大额支付，旅客自行承担信用卡在线支付手续费。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">10）行李规定</div>
    <div class="fontSize35 color2 lineheight5">根据您选择的行程及航空公司不同，托运行李的规定不同，请以各航空公司的规定为准，下列提示仅供参考：</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 免费托运行李：根据您选择的行程及航空公司不同，托运行李的规定不同。传统航空（相对廉价航空而言）行程，一般都允许免费托运一定额度的行李，具体以航空公司确认的为准；廉价航空没有免费托运行李，仅允许免费携带5-7KG左右的手提行李，如您需要托运行李，需额外支付费用购买。</div>
    <div class="fontSize35 color2 lineheight5">* 美国境内段航班没有免费托运行李，仅允许携带手提行李。</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 学生乘客类型：如您属于留学生身份，您可以选择学生乘客类型进行预订，价格方面，学生与普通乘客没有区别，但免费托运行李额度方面，学生可能会有一定的额外优惠，具体有没有学生行李优惠，请以客服确认的为准。</div>
    <div class="fontSize35 color2 lineheight5">* 普通乘客类型：如您选择普通乘客类型预订，则视为您接受普通乘客相应规定，包括但不限于托运行李额度等方面。</div>
    <div
      class="fontSize35 color2 lineheight5"
    >* 行李直挂：如您预订的行程为中转航班，托运行李是否可以从出发地直接托运到目的地，请以航空公司具体确认的为准。一般情况下，同一家航空公司承运的中转航班，托运行李可以直挂，不同航空公司承运的航班，托运行李无法直挂，此仅作为参考，行李托运及直挂事宜，请以航空公司值机柜台确认的为准。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">11）登机时间</div>
    <div
      class="fontSize35 color2 lineheight5"
    >国内航班一般提前1-2小时到达机场办理登机手续办理登机手续，航班起飞前45分钟停止办理；国际航班一般提前2-3小时到达机场办理登机手续办理登机手续，航班起飞前1小时停止办理（具体每个航空公司办理登机截止时间各有所不同，详情可致电相关航空公司确认；部分机场存在特殊调整的情况，请关注相关通知。）</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">11）登机时间</div>
    <div
      class="fontSize35 color2 lineheight5"
    >国内航班一般提前1-2小时到达机场办理登机手续办理登机手续，航班起飞前45分钟停止办理；国际航班一般提前2-3小时到达机场办理登机手续办理登机手续，航班起飞前1小时停止办理（具体每个航空公司办理登机截止时间各有所不同，详情可致电相关航空公司确认；部分机场存在特殊调整的情况，请关注相关通知。）</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">12）锂电池及充电宝安全运输规定</div>
    <div class="fontSize35 color2 lineheight5">请旅客遵照民航局发布相关规定执行。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">13）特殊餐食及服务申请</div>
    <div
      class="fontSize35 color2 lineheight5"
    >特殊餐食及服务一般需提前3天申请，如需要请在预订时注明，我司相关处理人员会把您的要求在您订座记录中传输到航空公司，但具体能否申请到，请直接致电所属航空公司进行确认。</div>

    <div class="fontSize4 blue2Color lineheight6" style="margin-top:0.3rem;">14）管辖法院</div>
    <div
      class="fontSize35 color2 lineheight5"
    >旅客同意因机票订单履行产生的纠纷，由双方协商解决，协商不成的，适用中华人民共和国的法律，任何一方均有权依法向广东省中山市人民法院起诉。</div>


    <div class="flexContainer">
      <div class="flexItem1" style="margin-top:0.3rem;">
        <div class="queryConditionsButton textalignM" @click="closeModel">知道了</div>
      </div>
    </div>

  </Modal>
</template>

<script>
export default {
  name: "TicketTipsModel",
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      showModel: false,
    };
  },
  components: {},
  activated: function () {},
  watch: {
    show: function (newValue, oldValue) {
      this.showModel = newValue;
    },
  },

  created() {},
  mounted() {},
  methods: {
    cancel() {
      this.$emit("close", this.showModel);
    },
    closeModel(){
      this.showModel = false;
      this.cancel();
    }
  },
};
</script>

<style scoped lang="less">
@import "../../style/home.less";
</style>



// WEBPACK FOOTER //
// src/components/child-components/TicketTipsModel.vue